var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"avatar",class:'avatar--' + _vm.size + ' avatar--' + _vm.variant},[_c('UiPicture',{attrs:{"src":_vm.src,"webp":_vm.webp,"width":_vm.size,"height":_vm.size,"alt":_vm.alt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }